import classNames from 'classnames'

import Button from '../Button'

import { DEFAULT_TEXT_BUTTON_HEIGHT } from './Text.constants'
import { getAfterIconProps, getBeforeIconProps } from './Text.utils'

import * as styles from './Text.module.css'

function Text({
  afterIconProps,
  beforeIconProps,
  className,
  height = DEFAULT_TEXT_BUTTON_HEIGHT,
  isActive,
  isGrey,
  isGreySecondary,
  isInline = true,
  underlined,
  ...restProps
}) {
  const buttonClassName = classNames(
    styles.text,
    {
      [styles.active]: isActive,
      [styles.basic]: !isGrey && !isGreySecondary,
      [styles.grey]: isGrey || isGreySecondary,
      [styles.greySecondary]: isGreySecondary,
      [styles.underline]: underlined,
    },
    className
  )

  return (
    <Button
      {...restProps}
      {...getBeforeIconProps({ beforeIconProps, height })}
      {...getAfterIconProps({ afterIconProps, height })}
      className={buttonClassName}
      height={height}
      isActive={isActive}
      isInline={isInline}
    />
  )
}

export default Text
